import type { TerrainQuery } from './TerrainQuery';
import { NO_TOP_REACH } from './terrainQueries';

/** Walkable tops that are not segment terrain – the roofs of obstacles (ObstacleManager.highestTopIn). */
export interface WalkableTopSource {
  /** Highest walkable top inside the track-space area that lies at most at `topReach`, or null. */
  highestTopIn(minZ: number, maxZ: number, minX: number, maxX: number, topReach: number): number | null;
}

/**
 * The ground a runner meets: the track's terrain plus the walkable tops of obstacles (container
 * roofs). An obstacle top only ever adds ground within the runner's reach (feet + one step) – it
 * never becomes a wall or a ceiling: the obstacle's colliders stay in charge of the front and the
 * sides (CollisionSystem → RunDirector). Queries without a reach see the plain terrain.
 */
export function withWalkableTops(terrain: TerrainQuery, tops: WalkableTopSource): TerrainQuery {
  return {
    groundHeightAt: (distance, x) => terrain.groundHeightAt(distance, x),
    highestGroundIn(minZ, maxZ, minX, maxX, topReach = NO_TOP_REACH) {
      const ground = terrain.highestGroundIn(minZ, maxZ, minX, maxX, topReach);
      if (topReach === NO_TOP_REACH) return ground;
      const top = tops.highestTopIn(minZ, maxZ, minX, maxX, topReach);
      if (top === null) return ground;
      return ground === null ? top : Math.max(ground, top);
    },
    lowestCeilingIn: (minZ, maxZ, minX, maxX, minHeight, filter, topReach) => terrain.lowestCeilingIn(minZ, maxZ, minX, maxX, minHeight, filter, topReach),
    pitFloorAt: (distance, x) => terrain.pitFloorAt(distance, x),
  };
}
